import { usePunditUserContext } from "@/react/contexts";
import { getCommunityIconUrl } from "@/react/helpers/communityHelpers";
import { useThemeContext } from "@circle-react/providers";

interface CommunityLogoProps {
  className?: string;
}

export const CommunityLogo = ({
  className = "h-14 w-14 rounded-xl",
}: CommunityLogoProps) => {
  const { currentCommunity } = usePunditUserContext();
  const { isDarkAppearance } = useThemeContext();

  const iconURL = getCommunityIconUrl(currentCommunity, isDarkAppearance);

  if (!iconURL) {
    return null;
  }

  return (
    <img
      src={iconURL}
      loading="lazy"
      alt={currentCommunity?.name ?? ""}
      className={className}
    />
  );
};
